// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qct-page {
  width: 100vw;
  min-height: 100vh;
  background: #f3f4f6;
  color: #172033;
}

.qct-header {
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 20px;
  background: #182033;
  color: #fff;
}

.qct-back,
.qct-toolbar button,
.qct-actions button {
  min-height: 44px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.qct-back {
  width: 92px;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.qct-title { display: flex; flex-direction: column; align-items: center; gap: 2px; }
.qct-title-line { display: flex; align-items: center; gap: 9px; }
.qct-title h1 { margin: 0; font-size: 22px; line-height: 1.15; }
.qct-test-badge {
  padding: 3px 7px;
  border-radius: 6px;
  background: #f59e0b;
  color: #231600;
  font-size: 11px;
  font-weight: 900;
}
.qct-header-spacer { width: 92px; }

.qct-main {
  box-sizing: border-box;
  height: calc(100vh - 74px);
  overflow-y: auto;
  padding: 18px;
}

.qct-scan-panel,
.qct-editor {
  max-width: 900px;
  margin: 0 auto;
}

.qct-scan-panel { max-width: 520px; text-align: center; }
.qct-scan-copy h2 { margin: 4px 0; font-size: 24px; }
.qct-scan-copy p { margin: 0 0 14px; color: #667085; }
.qct-scanner { overflow: hidden; border-radius: 14px; background: #fff; }
.qct-scanner .qr-scanner-viewport { max-width: min(460px, 88vw); margin: 0 auto; }
.qct-usb-prompt {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #7c3aed;
  background: #f5f3ff;
  font-size: 20px;
}
.qct-usb-prompt > span { font-size: 64px; }
.qct-loading { color: #667085; }

.qct-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border: 1px solid #d8dde7;
  border-radius: 14px;
  background: #fff;
}
.qct-eyebrow { margin: 0 0 3px; color: #7c3aed; font-size: 13px; font-weight: 800; }
.qct-summary h2 { margin: 0; font-size: 22px; }
.qct-count { min-width: 126px; text-align: right; color: #667085; }
.qct-count strong { color: #172033; font-size: 30px; }
.qct-count span { margin-left: 5px; font-weight: 700; }
.qct-count.complete strong { color: #15803d; }

.qct-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0 8px;
}
.qct-toolbar button { min-height: 38px; padding: 0 14px; background: #fff; border-color: #cfd5df; }
.qct-toolbar span { margin-left: auto; color: #667085; font-size: 13px; }

.qct-list { display: flex; flex-direction: column; gap: 7px; }
.qct-row {
  min-height: 58px;
  display: grid;
  grid-template-columns: 24px 28px minmax(0, 1fr) auto 58px;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  padding: 9px 13px;
  border: 1px solid #d8dde7;
  border-radius: 11px;
  background: #fff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.qct-row.checked { border-color: #86efac; background: #f0fdf4; }
.qct-row input { width: 21px; height: 21px; accent-color: #16a34a; }
.qct-order { color: #98a2b3; font-size: 13px; font-weight: 800; }
.qct-row-copy { min-width: 0; display: flex; flex-direction: column; }
.qct-row-copy strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 16px; }
.qct-row-copy small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #667085; margin-top: 2px; }
.qct-type { padding: 4px 7px; border-radius: 6px; background: #eef0f5; color: #475467; font-size: 12px; font-weight: 700; }
.qct-state { color: #98a2b3; font-size: 13px; font-weight: 800; text-align: right; }
.qct-row.checked .qct-state { color: #15803d; }

.qct-notice {
  margin-top: 12px;
  padding: 10px 12px;
  border-left: 3px solid #f59e0b;
  background: #fffbeb;
  color: #7c4a03;
  font-size: 13px;
  line-height: 1.5;
}
.qct-alert { margin-top: 10px; padding: 11px 13px; border-radius: 9px; font-weight: 700; }
.qct-alert.success { color: #166534; background: #dcfce7; }
.qct-alert.error { color: #991b1b; background: #fee2e2; }
.qct-empty { margin-top: 12px; padding: 36px 20px; text-align: center; color: #667085; background: #fff; border-radius: 12px; }

.qct-actions { display: flex; justify-content: flex-end; gap: 9px; margin-top: 13px; }
.qct-actions button { padding: 0 18px; }
.qct-secondary { background: #fff; color: #344054; border-color: #cfd5df !important; }
.qct-save { min-width: 150px; background: #7c3aed; color: #fff; }
.qct-actions button:disabled { opacity: 0.45; cursor: not-allowed; }

@media (max-width: 640px) {
  .qct-header { padding: 9px 12px; }
  .qct-title h1 { font-size: 18px; }
  .qct-back, .qct-header-spacer { width: 72px; }
  .qct-back { font-size: 13px; }
  .qct-main { padding: 12px; }
  .qct-summary { padding: 13px; }
  .qct-summary h2 { font-size: 18px; }
  .qct-count { min-width: 94px; }
  .qct-count strong { font-size: 25px; }
  .qct-toolbar { flex-wrap: wrap; }
  .qct-toolbar span { width: 100%; margin-left: 0; }
  .qct-row { grid-template-columns: 24px 22px minmax(0, 1fr) 52px; gap: 7px; }
  .qct-type { display: none; }
  .qct-actions { flex-wrap: wrap; }
  .qct-actions button { flex: 1 1 130px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/QuestCompletionTestPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA,aAAa,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnF,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE,gBAAgB,SAAS,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC/D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,qBAAqB,WAAW,EAAE;;AAElC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB,gBAAgB,EAAE,kBAAkB,EAAE;AACxD,oBAAoB,aAAa,EAAE,eAAe,EAAE;AACpD,mBAAmB,gBAAgB,EAAE,cAAc,EAAE;AACrD,eAAe,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACxE,oCAAoC,2BAA2B,EAAE,cAAc,EAAE;AACjF;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA,yBAAyB,eAAe,EAAE;AAC1C,eAAe,cAAc,EAAE;;AAE/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,eAAe,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnF,kBAAkB,SAAS,EAAE,eAAe,EAAE;AAC9C,aAAa,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAClE,oBAAoB,cAAc,EAAE,eAAe,EAAE;AACrD,kBAAkB,gBAAgB,EAAE,gBAAgB,EAAE;AACtD,6BAA6B,cAAc,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAClG,oBAAoB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAExE,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7D;EACE,gBAAgB;EAChB,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,mBAAmB,qBAAqB,EAAE,mBAAmB,EAAE;AAC/D,iBAAiB,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;AACnE,aAAa,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChE,gBAAgB,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACrE,uBAAuB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACxG,sBAAsB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AACvH,YAAY,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC1H,aAAa,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACnF,8BAA8B,cAAc,EAAE;;AAE9C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,aAAa,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACzF,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;AAC1D,mBAAmB,cAAc,EAAE,mBAAmB,EAAE;AACxD,aAAa,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE9H,eAAe,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACrF,sBAAsB,eAAe,EAAE;AACvC,iBAAiB,gBAAgB,EAAE,cAAc,EAAE,gCAAgC,EAAE;AACrF,YAAY,gBAAgB,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAChE,+BAA+B,aAAa,EAAE,mBAAmB,EAAE;;AAEnE;EACE,cAAc,iBAAiB,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,gCAAgC,WAAW,EAAE;EAC7C,YAAY,eAAe,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,eAAe,aAAa,EAAE;EAC9B,kBAAkB,eAAe,EAAE;EACnC,aAAa,eAAe,EAAE;EAC9B,oBAAoB,eAAe,EAAE;EACrC,eAAe,eAAe,EAAE;EAChC,oBAAoB,WAAW,EAAE,cAAc,EAAE;EACjD,WAAW,oDAAoD,EAAE,QAAQ,EAAE;EAC3E,YAAY,aAAa,EAAE;EAC3B,eAAe,eAAe,EAAE;EAChC,sBAAsB,eAAe,EAAE;AACzC","sourcesContent":[".qct-page {\n  width: 100vw;\n  min-height: 100vh;\n  background: #f3f4f6;\n  color: #172033;\n}\n\n.qct-header {\n  height: 74px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  padding: 10px 20px;\n  background: #182033;\n  color: #fff;\n}\n\n.qct-back,\n.qct-toolbar button,\n.qct-actions button {\n  min-height: 44px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.qct-back {\n  width: 92px;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.qct-title { display: flex; flex-direction: column; align-items: center; gap: 2px; }\n.qct-title-line { display: flex; align-items: center; gap: 9px; }\n.qct-title h1 { margin: 0; font-size: 22px; line-height: 1.15; }\n.qct-test-badge {\n  padding: 3px 7px;\n  border-radius: 6px;\n  background: #f59e0b;\n  color: #231600;\n  font-size: 11px;\n  font-weight: 900;\n}\n.qct-header-spacer { width: 92px; }\n\n.qct-main {\n  box-sizing: border-box;\n  height: calc(100vh - 74px);\n  overflow-y: auto;\n  padding: 18px;\n}\n\n.qct-scan-panel,\n.qct-editor {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.qct-scan-panel { max-width: 520px; text-align: center; }\n.qct-scan-copy h2 { margin: 4px 0; font-size: 24px; }\n.qct-scan-copy p { margin: 0 0 14px; color: #667085; }\n.qct-scanner { overflow: hidden; border-radius: 14px; background: #fff; }\n.qct-scanner .qr-scanner-viewport { max-width: min(460px, 88vw); margin: 0 auto; }\n.qct-usb-prompt {\n  min-height: 260px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: #7c3aed;\n  background: #f5f3ff;\n  font-size: 20px;\n}\n.qct-usb-prompt > span { font-size: 64px; }\n.qct-loading { color: #667085; }\n\n.qct-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 18px;\n  border: 1px solid #d8dde7;\n  border-radius: 14px;\n  background: #fff;\n}\n.qct-eyebrow { margin: 0 0 3px; color: #7c3aed; font-size: 13px; font-weight: 800; }\n.qct-summary h2 { margin: 0; font-size: 22px; }\n.qct-count { min-width: 126px; text-align: right; color: #667085; }\n.qct-count strong { color: #172033; font-size: 30px; }\n.qct-count span { margin-left: 5px; font-weight: 700; }\n.qct-count.complete strong { color: #15803d; }\n\n.qct-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 12px 0 8px;\n}\n.qct-toolbar button { min-height: 38px; padding: 0 14px; background: #fff; border-color: #cfd5df; }\n.qct-toolbar span { margin-left: auto; color: #667085; font-size: 13px; }\n\n.qct-list { display: flex; flex-direction: column; gap: 7px; }\n.qct-row {\n  min-height: 58px;\n  display: grid;\n  grid-template-columns: 24px 28px minmax(0, 1fr) auto 58px;\n  align-items: center;\n  gap: 10px;\n  box-sizing: border-box;\n  padding: 9px 13px;\n  border: 1px solid #d8dde7;\n  border-radius: 11px;\n  background: #fff;\n  cursor: pointer;\n  user-select: none;\n}\n.qct-row.checked { border-color: #86efac; background: #f0fdf4; }\n.qct-row input { width: 21px; height: 21px; accent-color: #16a34a; }\n.qct-order { color: #98a2b3; font-size: 13px; font-weight: 800; }\n.qct-row-copy { min-width: 0; display: flex; flex-direction: column; }\n.qct-row-copy strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 16px; }\n.qct-row-copy small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #667085; margin-top: 2px; }\n.qct-type { padding: 4px 7px; border-radius: 6px; background: #eef0f5; color: #475467; font-size: 12px; font-weight: 700; }\n.qct-state { color: #98a2b3; font-size: 13px; font-weight: 800; text-align: right; }\n.qct-row.checked .qct-state { color: #15803d; }\n\n.qct-notice {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-left: 3px solid #f59e0b;\n  background: #fffbeb;\n  color: #7c4a03;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.qct-alert { margin-top: 10px; padding: 11px 13px; border-radius: 9px; font-weight: 700; }\n.qct-alert.success { color: #166534; background: #dcfce7; }\n.qct-alert.error { color: #991b1b; background: #fee2e2; }\n.qct-empty { margin-top: 12px; padding: 36px 20px; text-align: center; color: #667085; background: #fff; border-radius: 12px; }\n\n.qct-actions { display: flex; justify-content: flex-end; gap: 9px; margin-top: 13px; }\n.qct-actions button { padding: 0 18px; }\n.qct-secondary { background: #fff; color: #344054; border-color: #cfd5df !important; }\n.qct-save { min-width: 150px; background: #7c3aed; color: #fff; }\n.qct-actions button:disabled { opacity: 0.45; cursor: not-allowed; }\n\n@media (max-width: 640px) {\n  .qct-header { padding: 9px 12px; }\n  .qct-title h1 { font-size: 18px; }\n  .qct-back, .qct-header-spacer { width: 72px; }\n  .qct-back { font-size: 13px; }\n  .qct-main { padding: 12px; }\n  .qct-summary { padding: 13px; }\n  .qct-summary h2 { font-size: 18px; }\n  .qct-count { min-width: 94px; }\n  .qct-count strong { font-size: 25px; }\n  .qct-toolbar { flex-wrap: wrap; }\n  .qct-toolbar span { width: 100%; margin-left: 0; }\n  .qct-row { grid-template-columns: 24px 22px minmax(0, 1fr) 52px; gap: 7px; }\n  .qct-type { display: none; }\n  .qct-actions { flex-wrap: wrap; }\n  .qct-actions button { flex: 1 1 130px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
